import store from '@/state/store'

export default [
  {
    path: '/',
    name: 'default',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/default'),
  },
  {
    path: '/confirmation',
    name: 'confirmation',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/confirmation')
  },
  {
    path: '/voucher',
    name: 'List Voucher',
    meta: { authRequired: true },
    component: () => import('./views/voucher/index')
  },
  {
    path: '/account',
    name: 'order',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/account')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/account/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
          store.dispatch('auth/logOut')
        } else {
          store.dispatch('authfack/logout')
        }
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
            (route) => route.push('/')
        )
        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { name: 'dashboard' } : { ...routeFrom })
      },
    },
  },
]
